import React from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import './styles/RedoMatching.css';

function RedoMatching({ user_id }) {
  const navigate = useNavigate();

  const handleRedo = async () => {
    try {
      const res = await api.get('/account_status/', {
        params: { user_id }
      });
      const data = res.data;

      if (data.status === 'success') {
        const { subscription } = data.account_status;
        const plan = subscription?.plan;
        const credits = subscription?.credits_remaining || 0;

        if (plan === 'essentials') {
          if (credits > 0) {
            navigate(`/find_venues/${user_id}`);
          } else {
            navigate(`/couples_plans/${user_id}`);
          }
        } else {
          navigate(`/find_venues/${user_id}`);
        }
      } else {
        navigate(`/matching_flow/${user_id}`);
      }
    } catch (error) {
      console.error("Error checking account status:", error);
      navigate(`/matching_flow/${user_id}`);
    }
  };

  return (
    <div className="redo-matching">
      <h2>Redo Matching</h2>
      <p>
        If you’d like to restart your preference matching process, click the button below.
      </p>
      <button className="redo-button" onClick={handleRedo}>
        Start Matching
      </button>
    </div>
  );
}

export default RedoMatching;